// 统计光标之前的字符串
const posCursor = obj => {
  var isIE = !!document.all;
  var end = 0;
  if (isIE) {
    var sTextRange = document.selection.createRange();
    if (sTextRange.parentElement() == obj) {
      var oTextRange = document.body.createTextRange();
      oTextRange.moveToElementText(obj);
      for (
        end = 0;
        oTextRange.compareEndPoints("StartToEnd", sTextRange) < 0;
        end++
      ) {
        oTextRange.moveStart("character", 1);
      }
      for (var i = 0; i <= end; i++) {
        if (obj.value.charAt(i) == "\n") {
          end++;
        }
      }
    }
  } else {
    end = obj.selectionEnd;
  }
  return end;
};

// 统计字符串总长度中文字符为2，英文字符及数字为1
const getLength = obj => {
  var realLength = 0,
    len = obj.length,
    charCode = -1;
  for (var i = 0; i < len; i++) {
    charCode = obj.charCodeAt(i);
    if (charCode >= 0 && charCode <= 128) realLength += 1;
    else realLength += 2;
  }
  return realLength;
};

// 统计字符串出现的次数
const tongJi = (string, char) => {
  var index = 0,
    index1 = 0,
    count = 0;
  for (var i = 0; i < string.length && index1 != -1; i++) {
    index1 = string.indexOf(char, index);
    index = index1 + 1;
    count = i;
  }
  return count;
};

const ATTENTION_EVENT = (textarea, CallBack) => {
//     var allLeft = 0; //修正列表位置，由于margin padding border产生的误差
//   var allTop = textarea.offsetTop; //修正列表位置，由于margin padding border产生的误差
//   var textareaWidth = textarea.offsetWidth;
//   console.log(textareaWidth, textarea.offsetTop, textarea.offsetLeft)
  //取值
  var objString = textarea.value;

  //记录光标当前位置
  var cursorPosition = posCursor(textarea);

  //光标之前的字符串
  var beforeAtString = objString.substr(0, cursorPosition);

  //记录@在光表前出现的最近的位置
  var atLocation = beforeAtString.lastIndexOf("@");

  //记录回车在光表前出现的最近的位置
  var enterLocation = ("\n" + beforeAtString).lastIndexOf("\n");

  //记录光标和光标前最近的@之间的字符串，记为标识符，判断其是否含有空格
  var indexString = objString.substr(atLocation, cursorPosition - atLocation);

  //记录光标和光标前最近的enter之间的字符串
  var enterString = objString.substr(
    enterLocation,
    cursorPosition - enterLocation
  );

  if (
    beforeAtString.indexOf("@") != -1 &&
    indexString.indexOf(" ") == -1 &&
    indexString.indexOf("\n") == -1
  ) {
    //Append contact list
    console.log("追加用户名");
    console.log(indexString);
    let dic = {
      objString: objString,
      objStringLength: getLength(objString),
      indexString: indexString,
      cursorPosition: cursorPosition,
      atLocation: atLocation
    };

    /*
    //Set position
    //Append span to save string
    var hiddenSpan = document.createElement("nobr");
    textarea.parentNode.appendChild(hiddenSpan);

    var enterAtString = "\n" + beforeAtString;
    var splitString = enterAtString.split("\n");
    var lastSplitString = splitString[splitString.length - 1];

    var powerTop = 0;

    for (var i = 0; i < splitString.length; i++) {
      hiddenSpan.innerHTML = splitString[i];
      powerTop += Math.floor(
        (hiddenSpan.offsetWidth + tongJi(lastSplitString, " ") * 3.86) /
          textareaWidth
      );
    }
    powerTop += tongJi(enterAtString, "\n");

    if (powerTop > textarea.rows) {
      powerTop = textarea.rows;
    }

    hiddenSpan.innerHTML = splitString[splitString.length - 1];

    var left =
      ((hiddenSpan.offsetWidth + tongJi(lastSplitString, " ") * 3.86) %
        textareaWidth) +
      allLeft;
    var top = powerTop * 20 + allTop;
    textarea.parentNode.removeChild(hiddenSpan);
    */
    if (CallBack) {
      CallBack(dic, true);
    }
  } else {
    if (CallBack) {
      CallBack("", false);
    }
  }
};
const objChange = (textarea, CallBack) => {
  //取值
  var objString = textarea.value;

  //记录光标当前位置
  var cursorPosition = posCursor(textarea);

  //光标之前的字符串
  var beforeAtString = objString.substr(0, cursorPosition);

  //记录@在光表前出现的最近的位置
  var atLocation = beforeAtString.lastIndexOf("@");

  //记录回车在光表前出现的最近的位置
  var enterLocation = ("\n" + beforeAtString).lastIndexOf("\n");

  //记录光标和光标前最近的@之间的字符串，记为标识符，判断其是否含有空格
  var indexString = objString.substr(atLocation, cursorPosition - atLocation);

  //记录光标和光标前最近的enter之间的字符串
  var enterString = objString.substr(
    enterLocation,
    cursorPosition - enterLocation
  );

  if (
    beforeAtString.indexOf("@") != -1 &&
    indexString.indexOf(" ") == -1 &&
    indexString.indexOf("\n") == -1
  ) {
    //Append contact list
    // console.log("追加用户名");
    // console.log(indexString)
    let dic = {
      objString: objString,
      objStringLength: getLength(objString),
      indexString: indexString,
      cursorPosition: cursorPosition,
      atLocation: atLocation
    };
    if (CallBack) {
      CallBack(dic, true);
    }
  } else {
    if (CallBack) {
      CallBack("", false);
    }
  }
};

const AT = (textarea, CallBack) => {
  if (textarea.addEventListener) {
    textarea.addEventListener(
      "keyup",
      () => {
        objChange(textarea, CallBack);
      },
      false
    );
    textarea.addEventListener(
      "mouseup",
      () => {
        objChange(textarea, CallBack);
      },
      false
    );
  } else if (textarea.attachEvent) {
    textarea.attachEvent("onkeyup", () => {
      objChange(textarea, CallBack);
    });
    textarea.attachEvent("onmouseup", () => {
      objChange(textarea, CallBack);
    });
  }
};

export { AT, ATTENTION_EVENT };
